import React from "react";

function Goatee1() {
  return (
    <>
      <path
        className="hairMediumShade"
        d="m 290.21377,302.00783 h -61.82389 a 19.866693,19.866693 0 0 0 -19.8667,19.85747 h 34.32611 a 19.820556,19.820556 0 0 0 16.44331,-8.71993 19.820556,19.820556 0 0 0 16.44331,8.71993 h 34.32611 a 19.866693,19.866693 0 0 0 -19.84825,-19.85747 z"
        id="path1838"
      />
      <path
        className="hairMediumShade"
        d="m 240.68084,357.33562 14.22872,21.60144 a 5.1027782,5.1027782 0 0 0 8.48925,0 l 14.50555,-21.60144 A 5.0935507,5.0935507 0 0 0 273.66897,349.4 h -28.73429 a 5.0935507,5.0935507 0 0 0 -4.25384,7.93562 z"
        id="path1840"
      />
    </>
  );
}

export default Goatee1;
